import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditConditionsPage from '@/features/jobs/job-edit-conditions/JobEditConditionsPage';

export const jobEditConditionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/condicoes-de-trabalho',
  component: JobEditConditionsPage,
});
